import { componentLabel } from '../utils/editor';
import objectGroupIcon from './icons/object-group.svg';
import loadComponent from './component';
import loadCommands from './commands';

function loadBlock(editor, options = {}) {
  editor.BlockManager.add(options.componentType, {
    label: componentLabel(options.componentName, objectGroupIcon),
    category: options.category,
    content: '<LearningPathwayCollection />'
  });
}

export default function (editor, opts = {}) {
  const defaults = {
    componentType: 'LearningPathwayCollection',
    componentName: 'Learning pathway collection',
    category: 'Learning pathway',
    modalTitle: 'Collection configuration',
    formElementID: 'nv-learning-pathway-collection-settings-form',
    componentKey: 'nv_learning_pathway_collection_settings',
    commands: {
      configure: 'nv:learning-pathway-collection:settings:open-modal'
    }
  };

  loadCommands(editor, {...defaults, ...opts});
  loadBlock(editor, { ...defaults, ...opts });
  loadComponent(editor, { ...defaults, ...opts });
}
